import React, { useContext, useEffect, useState } from "react";
import { PointingDetailsContext } from "../../../../../core/_context";
import { CardDetails } from "../../../../../../../common/components/CardDetails/CardDetails";
import style from "../style.module.scss";
import { HiCheckCircle } from "react-icons/hi";
import { MdCancel } from "react-icons/md";
import { FormatDate } from "../../../../../../../utilities/formatDate";
import { BsHourglassSplit } from "react-icons/bs";
import { PointingConstant } from "../../../../../core/_constant";
import { Tabs, Tag, Image, Tooltip, Modal } from "antd";
import dayjs from "dayjs";
import { EyeOutlined } from "@ant-design/icons";
import { buildCheckpointImages } from "../../../../../../../utilities/buildCheckpointImages";

const TYPE_CONSTANT = {
  on_board: "ON_BOARD",
  dockside: "DOCKSIDE",
  storage: "STORAGE",
  other: "OTHER",
};

export const VehicleDetailsData = () => {
  const { data } = useContext(PointingDetailsContext);
  const [loadData, setLoadData] = useState<any>({});

  useEffect(() => {
    setLoadData({});
    if (data?.pointingData?.length) {
      data?.pointingData?.forEach((item: any) => {
        if (item?.loadControlType?.id?.includes(TYPE_CONSTANT.on_board)) {
          setLoadData((prev: any) => ({
            ...prev,
            [TYPE_CONSTANT.on_board]: [
              ...(prev?.[TYPE_CONSTANT.on_board]
                ? [...prev?.[TYPE_CONSTANT.on_board]]
                : []),
              item,
            ],
          }));
        } else if (
          item?.loadControlType?.id?.includes(TYPE_CONSTANT.dockside)
        ) {
          setLoadData((prev: any) => ({
            ...prev,
            [TYPE_CONSTANT.dockside]: [
              ...(prev?.[TYPE_CONSTANT.dockside]
                ? [...prev?.[TYPE_CONSTANT.dockside]]
                : []),
              item,
            ],
          }));
        } else if (item?.loadControlType?.id?.includes(TYPE_CONSTANT.storage)) {
          setLoadData((prev: any) => ({
            ...prev,
            [TYPE_CONSTANT.storage]: [
              ...(prev?.[TYPE_CONSTANT.storage]
                ? [...prev?.[TYPE_CONSTANT.storage]]
                : []),
              item,
            ],
          }));
        } else {
          setLoadData((prev: any) => ({
            ...prev,
            [TYPE_CONSTANT.other]: [
              ...(prev?.[TYPE_CONSTANT.other]
                ? [...prev?.[TYPE_CONSTANT.other]]
                : []),
              item,
            ],
          }));
        }
      });
    }
  }, [data]);

  const getTitle = (type: string) => {
    switch (type) {
      case TYPE_CONSTANT.on_board:
        return "À bord";
      case TYPE_CONSTANT.dockside:
        return "À quai";
      case TYPE_CONSTANT.storage:
        return "Entreposage";
      case TYPE_CONSTANT.other:
        return "Autre";
      default:
        return "Inconnu";
    }
  };

  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryImages, setGalleryImages] = useState<Array<{ url: string; title?: string }>>([]);

  const openGallery = (imgs: Array<{ url: string; title?: string }>) => {
    setGalleryImages(imgs);
    setGalleryOpen(true);
  };

  const tabsItems = Object.keys(loadData).map((type) => ({
    key: type,
    label: getTitle(type),
    children: (
      <div className={style.details__checkpoint_container}>
        {loadData[type]?.map((item: any, index: number) => (
          <div
            className={`${style.details__checkpoint_content} ${
              item?.loadControlState?.id ===
              PointingConstant.CHECKPOINT_NOK
                ? style.details__checkpoint_error
                : ""
            }`}
            key={index}
          >
            {/* ===== CONTENU EXISTANT INCHANGÉ ===== */}
            <div className={style.details__checkpoint_item_wrapper_title}>
                    <div className={style.details__checkpoint_item}>
                      <span className={style.details__checkpoint_subtitle}>
                        {" "}
                        {item?.loadControlType?.name}{" "}
                      </span>
                      <span className={style.details__checkpoint_name}>
                        {" "}
                        {item?.checkedBy?.fullname}{" "}
                      </span>
                    </div>
                    <div className={style.details__checkpoint_item}>
                      {item?.loadControlState?.id ===
                      PointingConstant.CHECKPOINT_OK ? (
                        <HiCheckCircle
                          className={style.details__checkpoint_icon_ok}
                        />
                      ) : (
                        ""
                      )}
                      {item?.loadControlState?.id ===
                      PointingConstant.CHECKPOINT_IN_PROGRESS ? (
                        <BsHourglassSplit
                          className={style.details__checkpoint_icon_progress}
                        />
                      ) : (
                        ""
                      )}

                      {item?.loadControlState?.id ===
                      PointingConstant.CHECKPOINT_NOK ? (
                        <MdCancel
                          className={style.details__checkpoint_icon_cancel}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    {item?.hold && (
                      <div className={style.details__checkpoint_item}>
                      <span className={style.details__checkpoint_subtitle}>
                        {" "}
                        {"Numéro de cale"}{" "}
                      </span>
                      <span className={style.details__checkpoint_name}>
                        {" "}
                        {item?.hold}{" "}
                      </span>
                      </div>
                    )}
                    {item?.barge && (
                      <div className={style.details__checkpoint_item}>
                      <span className={style.details__checkpoint_subtitle}>
                        {" "}
                        {"Chaland"}{" "}
                      </span>
                      <span className={style.details__checkpoint_name}>
                        {" "}
                        {item?.barge?.reference}{" "}
                      </span>
                      </div>
                    )}
                  </div>
                  {(() => {
                    const imgs = buildCheckpointImages(item);
                    if (!imgs.length) return null;

                    const showOverlayTile = imgs.length > 3;
                    const visibleTiles = showOverlayTile ? imgs.slice(0, 4) : imgs; // 1..4
                    const remaining = showOverlayTile ? imgs.length - 3 : 0;

                    return (
                      <div className={style.details__thumbs_row}>
                        <span className={style.details__checkpoint_subtitle}>Photos</span>

                        <Image.PreviewGroup>
                          <div className={style.details__thumb_grid}>
                            {/* 1-3 images preview */}
                            {visibleTiles.map((img, idx) => {
                              const isFourthOverlay = showOverlayTile && idx === 3;

                              if (!isFourthOverlay) {
                                return (
                                  <Tooltip key={idx} title={img.title}>
                                    <Image
                                      src={img.url}
                                      className={style.details__thumb_tile}
                                      preview={{ mask: <EyeOutlined /> }}
                                    />
                                  </Tooltip>
                                );
                              }

                              return (
                                <div
                                  key={idx}
                                  className={`${style.details__thumb_tile} ${style.details__thumb_overlay_container}`}
                                  onClick={() => openGallery(imgs)}
                                  role="button"
                                  tabIndex={0}
                                >
                                  <Image src={img.url} className={style.details__thumb_tile_img} preview={false} />
                                  <div className={style.details__thumb_overlay}>+{remaining}</div>
                                </div>
                              );
                            })}
                          </div>

                          {/* AJOUT IMPORTANT */}
                          <div style={{ display: "none" }}>
                            {imgs.slice(3).map((img, idx) => (
                              <Image key={`hidden-${idx}`} src={img.url} />
                            ))}
                          </div>
                        </Image.PreviewGroup>

                        {/* Modal */}
                        <Modal
                          open={galleryOpen}
                          onCancel={() => setGalleryOpen(false)}
                          footer={null}
                          width={850}
                          centered
                          title="Photos"
                          destroyOnClose
                        >
                          <Image.PreviewGroup>
                            <div className={style.details__gallery_grid}>
                              {galleryImages.map((img, idx) => (
                                <div key={idx} className={style.details__gallery_item}>
                                  <Image
                                    src={img.url}
                                    className={style.details__gallery_img}
                                    preview={{ mask: <EyeOutlined /> }}
                                  />
                                  {img.title ? (
                                    <div className={style.details__gallery_caption}>{img.title}</div>
                                  ) : null}
                                </div>
                              ))}
                            </div>
                          </Image.PreviewGroup>
                        </Modal>
                      </div>
                    );
                  })()}

                  <div className={style.details__checkpoint_item_wrapper}>
                    <div className={style.details__checkpoint_item_comment}>
                      {item?.loadDamages && item?.loadDamages?.length ? (
                        <div className="">
                          <span className={style.details__checkpoint_subtitle}>
                            {" "}
                            Avaries
                          </span>
                          <div
                            className="mb-2 pb-2"
                            style={{
                              borderBottom: "dashed #CBCBCB 1px",
                            }}
                          >
                            {item?.loadDamages?.map((damage: any) => (
                              <Tag color="volcano">{damage?.name}</Tag>
                            ))}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <span className={style.details__checkpoint_subtitle}>
                        {" "}
                        Commentaire
                      </span>
                      <span className={style.details__checkpoint_comment}>
                        {" "}
                        {item?.comment}
                      </span>
                    </div>
                    <div className={style.details__checkpoint_item}>
                      <span
                        className={style.details__checkpoint_time}
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {item?.startAt
                          ? dayjs(item?.startAt, "DD/MM/YYYY HH:mm").format(
                              "DD/MM/YYYY"
                            )
                          : "-"}{" "}
                      </span>

                      <span className={style.details__checkpoint_time}>
                        {" "}
                        {item?.startAt
                          ? FormatDate.getDayjsTime(item?.startAt)
                          : "-"}{" "}
                        -{" "}
                        {item?.endAt
                          ? FormatDate.getDayjsTime(item?.endAt)
                          : "-"}{" "}
                      </span>
                    </div>
                  </div>
          </div>
        ))}
      </div>
    ),
  }));

  const renderValue = (value: any /* string | number | boolean */) => {
    return value ? value : "-";
  };

  return (
    <div className={style.details}>
      <CardDetails className="d-flex gap-2 flex-column">
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Immatriculation : </span>
          <span className={style.details__value}>
            {renderValue(data?.registrationNumber)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Marque : </span>
          <span className={style.details__value}>
            {renderValue(data?.brand)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Modèle : </span>
          <span className={style.details__value}>
            {renderValue(data?.model)}
          </span>
        </div>
        { data?.loadFillingStatus?.id === "FILLED" && (
          <div className={style.details__item}>
            <span className={style.details__subtitle}>Numéro de série : </span>
            <span className={style.details__value}>
                {renderValue(data?.serialNumber)}
            </span>
          </div>
        )}
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Statut du contrôle : </span>
          <span className={style.details__value}>
            {renderValue(data?.loadState?.name)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Opérationnel : </span>
          <span className={style.details__value}>
          {data?.operational ? "Oui" : "Non"}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Tonnage : </span>
          <span className={style.details__value}>
            {renderValue(data?.tonnage)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Volume : </span>
          <span className={style.details__value}>
            {renderValue(data?.volume)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Longueur : </span>
          <span className={style.details__value}>
            {renderValue(data?.length)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Largeur : </span>
          <span className={style.details__value}>
            {renderValue(data?.width)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Hauteur : </span>
          <span className={style.details__value}>
            {renderValue(data?.height)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Quantité : </span>
          <span className={style.details__value}>
            {renderValue(data?.qty)}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Importé : </span>
          <span className={style.details__value}>
            {data?.imported ? "Oui" : "Non"}
          </span>
        </div>
    </CardDetails>

      <div className={style.details__checkpoint}>
        <span className={style.details__checkpoint_title}> Checkpoint </span>

        <Tabs
            items={tabsItems}
            destroyInactiveTabPane
          />
        </div>

    </div>
  );
};
